"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNewFieldValue = exports["default"] = exports.Player = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdWysiwyg = require("cccisd-wysiwyg");
var _defaultTemplate = _interopRequireDefault(require("./defaultTemplate.js"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _cccisdFormik = require("cccisd-formik");
var _classnames2 = _interopRequireDefault(require("classnames"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _settings = require("./settings.js");
var _settings2 = require("../Builder/settings.js");
var _Target = _interopRequireDefault(require("./Target"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /* eslint-disable no-nested-ternary, no-loop-func */
var ConditionalWrapper = function ConditionalWrapper(_ref) {
  var condition = _ref.condition,
    wrapper = _ref.wrapper,
    children = _ref.children;
  return condition ? wrapper(children) : children;
};
var getNewFieldValue = exports.getNewFieldValue = function getNewFieldValue(_ref2) {
  var oldValue = _ref2.oldValue,
    settings = _ref2.settings,
    item = _ref2.item,
    targetId = _ref2.targetId,
    targetIndex = _ref2.targetIndex;
  var newValue = (0, _cloneDeep2["default"])(oldValue);
  var targets = newValue.targets;
  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
      key = _Object$entries$_i[0],
      value = _Object$entries$_i[1];
    targets[key] = value.filter(function (element, index) {
      var found = element.id === item.id && element.type === item.group;
      if (found && +key === targetId && index < targetIndex) {
        targetIndex--;
      }
      return !found;
    });
    if (targets[key].length === 0) {
      delete targets[key];
    }
  };
  for (var _i = 0, _Object$entries = Object.entries(targets); _i < _Object$entries.length; _i++) {
    _loop();
  }
  if (targetId !== 'source') {
    targets[targetId] = targets[targetId] || [];
    targets[targetId] = [].concat(_toConsumableArray(targets[targetId].slice(0, targetIndex)), [{
      type: item.group,
      id: item.id,
      label: item.label
    }], _toConsumableArray(targets[targetId].slice(targetIndex)));
  }

  // Adjust correctness
  if (settings.allowCorrectAnswers) {
    var targetType = settings.targetTypes["static"].find(function (target) {
      return target.id === targetId;
    });
    if (!targetType || !targetType.correctItems || !targetType.correctItems.includes(item.id)) {
      newValue.incorrect = newValue.incorrect || {};
      newValue.incorrect[item.id] = (newValue.incorrect[item.id] || 0) + 1;
    }
  }
  return newValue;
};
var validateUserItem = function validateUserItem(userItemTotal, values) {
  var errors = {};
  if (userItemTotal >= _settings2.MAX_USER_ITEMS) {
    errors.label = "You can enter only ".concat(_settings2.MAX_USER_ITEMS, " items");
  } else if (!values.label || values.label.trim() === '') {
    errors.label = 'You have to type your item';
  }
  return errors;
};
var Player = exports.Player = /*#__PURE__*/function (_React$Component) {
  _inherits(Player, _React$Component);
  function Player() {
    var _this;
    _classCallCheck(this, Player);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Player, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "mounted", true);
    _defineProperty(_assertThisInitialized(_this), "state", {
      feedbackMessage: {},
      placeholder: null
    });
    _defineProperty(_assertThisInitialized(_this), "getFieldValue", function () {
      return _this.props.field.value || {
        targets: {},
        incorrect: {}
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getNewUserLabelId", function () {
      var fieldValue = _this.getFieldValue();
      var userIds = new Set();
      for (var _i2 = 0, _Object$values = Object.values(fieldValue.targets); _i2 < _Object$values.length; _i2++) {
        var target = _Object$values[_i2];
        var _iterator = _createForOfIteratorHelper(target),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (item.type === 'user') {
              userIds.add(item.id);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      var id = 1;
      while (userIds.has(id)) {
        id++;
      }
      return id;
    });
    _defineProperty(_assertThisInitialized(_this), "addUserInput", function (values, _ref3) {
      var resetForm = _ref3.resetForm;
      var label = values.label,
        targetId = values.targetId;
      var id = _this.getNewUserLabelId();
      var oldValue = _this.getFieldValue();
      var newValue = (0, _cloneDeep2["default"])(oldValue);
      var targets = newValue.targets;
      targets[targetId] = targets[targetId] || [];
      targets[targetId].push({
        id: id,
        type: 'user',
        label: label
      });
      _this.props.field.onChange(newValue);
      resetForm();
    });
    _defineProperty(_assertThisInitialized(_this), "deleteItem", function (item) {
      var oldValue = _this.getFieldValue();
      var newValue = (0, _cloneDeep2["default"])(oldValue);
      for (var _i3 = 0, _Object$entries2 = Object.entries(newValue.targets); _i3 < _Object$entries2.length; _i3++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2),
          targetId = _Object$entries2$_i[0],
          items = _Object$entries2$_i[1];
        newValue.targets[targetId] = items.filter(function (obj) {
          return obj.type !== item.type || obj.id !== item.id;
        });
        if (newValue.targets[targetId].length === 0) {
          delete newValue.targets[targetId];
        }
      }
      _this.props.field.onChange(newValue);
    });
    _defineProperty(_assertThisInitialized(_this), "setPlaceholder", function (placeholder) {
      var currentPlaceholder = _this.state.placeholder;
      if (placeholder && currentPlaceholder && placeholder.targetId === currentPlaceholder.targetId && placeholder.indexAfter === currentPlaceholder.indexAfter) {
        return;
      }
      if (placeholder) {
        _this.setState({
          placeholder: _objectSpread(_objectSpread({}, currentPlaceholder), placeholder)
        });
      } else {
        _this.setState({
          placeholder: placeholder
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "showFeedbackMessage", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(msg) {
        var isCorrect,
          id,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              isCorrect = _args.length > 1 && _args[1] !== undefined ? _args[1] : null;
              id = +new Date();
              _this.setState({
                feedbackMessage: {
                  id: id,
                  msg: msg,
                  stage: 'prepare',
                  isCorrect: isCorrect
                }
              });
              _context.next = 5;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 200);
              });
            case 5:
              if (!(!_this.mounted || _this.state.feedbackMessage.id !== id)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              _this.setState({
                feedbackMessage: {
                  id: id,
                  msg: msg,
                  stage: 'show',
                  isCorrect: isCorrect
                }
              });
              _context.next = 10;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 3000);
              });
            case 10:
              if (!(!_this.mounted || _this.state.feedbackMessage.id !== id)) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return");
            case 12:
              _this.setState({
                feedbackMessage: {
                  id: id,
                  msg: msg,
                  stage: 'remove',
                  isCorrect: isCorrect
                }
              });
              _context.next = 15;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            case 15:
              if (!(!_this.mounted || _this.state.feedbackMessage.id !== id)) {
                _context.next = 17;
                break;
              }
              return _context.abrupt("return");
            case 17:
              _this.setState({
                feedbackMessage: {}
              });
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "renderSourceBlock", function () {
      var sources = _this.props.settings.sources;
      if (_this.props.isPreview) {
        return /*#__PURE__*/_react["default"].createElement("div", null, sources.map(function (item) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: item.id,
            className: _style["default"].sourceItem
          }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
            content: item.label
          }));
        }));
      }
      var fieldValue = _this.getFieldValue();
      var usedSourceIds = new Set();
      for (var _i4 = 0, _Object$values2 = Object.values(fieldValue.targets); _i4 < _Object$values2.length; _i4++) {
        var target = _Object$values2[_i4];
        var _iterator2 = _createForOfIteratorHelper(target),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            if (item.type === 'source') {
              usedSourceIds.add(item.id);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      var items = sources.filter(function (item) {
        return !usedSourceIds.has(item.id);
      }).map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          type: 'source'
        });
      });
      return /*#__PURE__*/_react["default"].createElement(_Target["default"], {
        targetId: "source",
        items: items,
        itemProps: {
          allowDelete: false,
          playItemAudio: true,
          deleteItem: _this.deleteItem
        },
        placeholder: _this.state.placeholder,
        setPlaceholder: _this.setPlaceholder,
        moveItem: _this.moveItem
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getTargetItems", function () {
      var _this$props$settings = _this.props.settings,
        imageLayout = _this$props$settings.imageLayout,
        targets = _this$props$settings.targets,
        targetTypes = _this$props$settings.targetTypes,
        feedbackTexts = _this$props$settings.feedbackTexts,
        showFeedback = _this$props$settings.showFeedback,
        allowCorrectAnswers = _this$props$settings.allowCorrectAnswers,
        showCorrectStyle = _this$props$settings.showCorrectStyle,
        feedbackPosition = _this$props$settings.feedbackPosition;
      var fieldValue = _this.getFieldValue();
      return targets.map(function (target) {
        var items = fieldValue.targets[target.id] || [];
        var _targetTypes$static$f = targetTypes["static"].find(function (type) {
            return type.id === target.id;
          }),
          showTargetLabel = _targetTypes$static$f.showTargetLabel,
          allowUserItem = _targetTypes$static$f.allowUserItem,
          correctItems = _targetTypes$static$f.correctItems;
        var userItemTotal = items.filter(function (item) {
          return item.type === 'user';
        }).length;
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: target.id,
          "data-target": target.id,
          className: _style["default"].targetWrapper
        }, showTargetLabel && imageLayout && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].targetTitle
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: target.label
        })), _this.props.isPreview ? /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].targetItem
        }) : /*#__PURE__*/_react["default"].createElement(_Target["default"], {
          targetId: target.id,
          items: items,
          itemProps: {
            deleteItem: _this.deleteItem,
            showFeedbackMessage: _this.showFeedbackMessage,
            showCorrectness: allowCorrectAnswers && showCorrectStyle,
            correctItems: correctItems,
            showFeedback: showFeedback,
            feedbackTexts: feedbackTexts,
            feedbackPosition: feedbackPosition
          },
          placeholder: _this.state.placeholder,
          setPlaceholder: _this.setPlaceholder,
          moveItem: _this.moveItem,
          className: _style["default"].targetItem
        }), !allowCorrectAnswers && allowUserItem && /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
          onSubmit: _this.addUserInput,
          initialValues: {
            label: '',
            targetId: target.id
          },
          validate: validateUserItem.bind(null, userItemTotal),
          render: function render(_ref5) {
            var handleSubmit = _ref5.handleSubmit,
              isValid = _ref5.isValid,
              errors = _ref5.errors;
            return /*#__PURE__*/_react["default"].createElement("div", {
              className: _style["default"].userInputBlock
            }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
              name: "label",
              render: function render(_ref6) {
                var field = _ref6.field;
                return /*#__PURE__*/_react["default"].createElement("input", _extends({}, field, {
                  "data-user-input": target.id,
                  className: "form-control input-sm",
                  type: "text",
                  placeholder: "Enter your own",
                  autoComplete: "off",
                  onKeyPress: function onKeyPress(event) {
                    if (event.charCode === 13) {
                      event.preventDefault();
                      handleSubmit();
                    }
                  }
                }));
              }
            })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(ConditionalWrapper, {
              condition: errors.label,
              wrapper: function wrapper(children) {
                return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
                  title: errors.label,
                  type: "error",
                  tippyProps: {
                    hideOnClick: false
                  }
                }, children);
              }
            }, /*#__PURE__*/_react["default"].createElement("button", {
              className: "btn btn-default btn-sm",
              "data-add-user-input": target.id,
              type: "submit",
              onClick: handleSubmit,
              disabled: !isValid
            }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null)))));
          }
        }));
      });
    });
    _defineProperty(_assertThisInitialized(_this), "moveItem", function (item, targetId, targetIndex) {
      var settings = _this.props.settings;
      var oldValue = _this.getFieldValue();
      var newValue = getNewFieldValue({
        oldValue: oldValue,
        settings: settings,
        item: item,
        targetId: targetId,
        targetIndex: targetIndex
      });
      _this.props.field.onChange(newValue);
    });
    _defineProperty(_assertThisInitialized(_this), "renderFeedback", function () {
      var _this$state$feedbackM = _this.state.feedbackMessage,
        id = _this$state$feedbackM.id,
        msg = _this$state$feedbackM.msg,
        stage = _this$state$feedbackM.stage,
        isCorrect = _this$state$feedbackM.isCorrect;
      if (!id) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        key: id,
        "data-fixed-feedback": true,
        className: (0, _classnames2["default"])(_style["default"].feedbackMessage, _style["default"][stage], _defineProperty(_defineProperty({}, _style["default"].right, isCorrect === true), _style["default"].wrong, isCorrect === false))
      }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
        content: msg
      }));
    });
    return _this;
  }
  _createClass(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.isPreview) {
        document.body.classList.add(_style["default"].disableSelect);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      if (!this.props.isPreview) {
        document.body.classList.remove(_style["default"].disableSelect);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        settings = _this$props.settings,
        showRequiredState = _this$props.showRequiredState,
        accommodations = _this$props.accommodations,
        showQuestionNumbers = _this$props.showQuestionNumbers,
        startQuestionNumber = _this$props.startQuestionNumber;
      var elementStyle = (0, _get2["default"])(this.props, 'playerTemplateProps.playerTemplateSettings.elementStyle');
      var templateProps = _objectSpread({
        question: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.question,
          showRequiredState: showRequiredState && settings.isRequired,
          registerAction: this.props.registerAction.bind(null, 1),
          setParameters: this.props.setParameters,
          accommodations: accommodations,
          prependWith: showQuestionNumbers && "".concat(startQuestionNumber, ". ")
        }), settings.description && /*#__PURE__*/_react["default"].createElement("div", {
          className: _style["default"].description
        }, /*#__PURE__*/_react["default"].createElement(_cccisdWysiwyg.Html, {
          content: settings.description
        }))),
        sourceBlock: this.renderSourceBlock(),
        targetItems: this.getTargetItems(),
        feedback: this.renderFeedback(),
        placeholder: this.state.placeholder,
        // Advanced props
        settings: settings,
        playerTemplateProps: this.props.playerTemplateProps,
        accommodations: accommodations,
        elementStyle: elementStyle
      }, this.props.templateExtraProps);
      var Template = this.props.template || _defaultTemplate["default"];
      return /*#__PURE__*/_react["default"].createElement(Template, templateProps);
    }
  }]);
  return Player;
}(_react["default"].Component);
_defineProperty(Player, "propTypes", {
  field: _propTypes["default"].object,
  accommodations: _propTypes["default"].object,
  playerTemplateProps: _propTypes["default"].object,
  registerAction: _propTypes["default"].func,
  setParameters: _propTypes["default"].func,
  settings: _propTypes["default"].object,
  showQuestionNumbers: _propTypes["default"].bool,
  showRequiredState: _propTypes["default"].bool,
  template: _propTypes["default"].func,
  templateExtraProps: _propTypes["default"].object,
  isPreview: _propTypes["default"].bool
});
_defineProperty(Player, "defaultProps", {
  registerAction: function registerAction() {},
  setParameters: function setParameters() {}
});
var _default = exports["default"] = (0, _cccisdSurveyCommon.playerWrapper)({
  validate: _settings.validate
})(Player);